import ApiClient from 'api-client/ApiClient'

// The console proxy needs the user's Keystone token, and the console page can't
// read it, so the page asks for it with a postMessage each time it loads. The
// reply only goes to the console's origin, and the token never touches the URL.
export const openConsoleWindow = (url: string) => {
  const consoleWindow = window.open(url, '_blank')
  window.addEventListener('message', (e) => {
    if (e.source === consoleWindow && e.data?.type === 'console-ready') {
      consoleWindow.postMessage(
        { type: 'auth', token: ApiClient.getInstance().scopedToken },
        new URL(url).origin,
      )
    }
  })
  return consoleWindow
}
